import useApi from '../../services/request.service';
import { StoreContext } from '../../context/Provider';
import { useContext, useEffect } from 'react';

import { ToastComponent } from '../../components/ToastComponent';
import { ISamInventory } from '../../interfaces/service/SandboxServiceManagerInterface';
import { locationPermissionService } from '../../services/locationPermissionService';
import { getCurrentPosition, ICoordinates } from '../../utils/utils';

export const useSandbox = (queryParams: string = '') => {
  const { getSandboxState } = useContext(StoreContext);
  const { genericApiCallApiBilling } = useApi();
  const getSandBoxData = async (queryRequest: string = '') => {
    const currentStatus = locationPermissionService.getPermissionStatus();
    if (currentStatus !== 'granted') {
      ToastComponent(
        'warning',
        'Error',
        'Por favor activa la ubicación para continuar.',
        6000
      );
      return;
    }

    let coords: ICoordinates =
      await locationPermissionService.getCurrentCoordinates();
    getSandboxState.initGetSandbox();

    try {
      const urlQuery: string = `/v1.0/sam-inventory/sandbox?${queryRequest}`;
      const result: any = await genericApiCallApiBilling(
        urlQuery,
        'GET',
        {},
        {},
        {
          appId: 'web',
          locationGPS: `${coords?.latitude}, ${coords?.longitude}`,
        }
      );

      const payload: ISamInventory[] = result.data;
      console.log('payload', payload);
      if (result.status === 200) {
        getSandboxState.getSandboxSuccess(payload);
      }
      return result;
    } catch (error: any) {
      getSandboxState.getSandboxError(error.message);
      ToastComponent('', '', error.message, 6000);
    }
  };

  useEffect(() => {
    if (
      getSandboxState.state.data === null &&
      getSandboxState.state.error === null &&
      getSandboxState.state.loading === false
    ) {
      getSandBoxData(queryParams);
    }
  }, [getSandboxState.state]);

  function downloadCSV(data: any, filename = 'Sandbox.csv') {
    const blob = new Blob(['\uFEFF' + data], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  const sandboxExportExcel = async (
    columnsQueryParams: any,
    queryRequest: string = ''
  ) => {
    getSandboxState.initGetSandboxExport();
    let coords: ICoordinates =
      await locationPermissionService.getCurrentCoordinates();
    try {
      const headers = {
        appId: 'web',
        locationGPS: `${coords?.latitude}, ${coords?.longitude}`
      };
      const urlQuery = `/v1.0/sam-inventory/download?${queryRequest}&${columnsQueryParams}`;
      const result: any = await genericApiCallApiBilling(
        urlQuery,
        'GET',
        {},
        {},
        headers
      );
      const payload = result.data;
      if (result.status === 200) {
        getSandboxState.getSandboxExportSuccess(payload);
        if (payload !== null && payload !== undefined) {
          downloadCSV(payload);
        } else if (payload === '') {
          ToastComponent('warning', 'Error', 'No hay datos para excel.', 6000);
        } else {
          ToastComponent(
            'warning',
            'Error',
            'Hay un problema en la solicitud.',
            6000
          );
        }
      }
    } catch (error: any) {
      ToastComponent('warning', 'Error', error.message, 6000);
      getSandboxState.getSandboxExportError(error.message);
    }
  };

  return { getSandBoxData, sandboxExportExcel };
};
